import { useEffect } from 'react';

export const resizeMap = (imageId: string, mapName: string) => {
  const image = document.getElementById(imageId) as HTMLImageElement;
  if (!image) {
    return;
  }

  const map = document.querySelector(`map[name="${mapName}"]`) as HTMLMapElement;
  if (!map) {
    return;
  }

  const imageWidth = image.offsetWidth;
  const originalWidth = image.naturalWidth;
  const scale = imageWidth / originalWidth;

  map.querySelectorAll('area').forEach(area => {
    const originalCoords = area.dataset.originalCoords || area.getAttribute('coords');
    // eslint-disable-next-line no-param-reassign
    area.dataset.originalCoords = originalCoords || '';
    if (originalCoords) {
      const coords = originalCoords.split(',').map(coord => Math.round(parseInt(coord, 10) * scale));
      area.setAttribute('coords', coords.join(','));
    }
  });
};

export const useResponsiveImageMap = (imageId: string, mapName: string) => {
  useEffect(() => {
    const updateMap = () => {
      resizeMap(imageId, mapName);
    };

    const image = document.getElementById(imageId) as HTMLImageElement;
    if (!image) {
      return () => {};
    }

    image.addEventListener('load', updateMap);

    const observer = new MutationObserver(() => {
      if (image.complete) {
        updateMap();
      }
    });

    observer.observe(image, {
      attributes: true,
      attributeFilter: ['src'],
    });

    window.addEventListener('resize', updateMap);
    requestAnimationFrame(updateMap);

    return () => {
      window.removeEventListener('resize', updateMap);
      const currentImage = document.getElementById(imageId) as HTMLImageElement;
      if (currentImage) {
        currentImage.removeEventListener('load', updateMap);
      }
      observer.disconnect();
    };
  }, [imageId, mapName]);
};
